/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Modal } from '@mui/material';
import { styled } from '@mui/system';

import './index.scss';
import Color from '@tool/color';
import moStore, {
  contactService, toggleAddModal, requestChance,
} from '@store/index';
// import moTop, { memberModel } from '../store/top';
import { CloseIcon20 } from '@styled/icon';
import moUser from '@store/user';
import posthog from 'posthog-js';
import Service from '@service/index';
import moSkin from '@store/skin';

interface IProps { }
interface IState { }

const SubButton = styled(Button)(() => ({
  width: '180px',
  height: '36px',
  borderRadius: '18px',
  background: Color.secondaryColor(1),
  // display: 'flex',
  // justifyContent: 'space-between',
  padding: '0 20px',
  color: Color.white,
  '&:hover': {
    backgroundColor: Color.secondaryColor(1),
  },
  '& svg': {
    marginLeft: '10px',
  },
}));

const NextButton = styled(Button)(() => ({
  width: '180px',
  height: '36px',
  borderRadius: '20px',
  background: Color.fff,
  padding: '0 20px',
  border: `1px solid ${Color.ec}`,
  color: Color.c55,
  '& svg': {
    marginLeft: '10px',
  },
}));

const AddReportModal = (props: IProps, state: IState) => {
  const { isAddModal, count } = moStore;
  const { userInfo } = moUser;
  const { partner } = moSkin;
  const onSure = () => {
    posthog.capture('无次数弹窗-直接联系顾问按钮', {});
    contactService();
    toggleAddModal(false);
  };
  const cancel = () => {
    toggleAddModal(false);
  };

  const getNumber = async () => {
    posthog.capture('无次数弹窗-获取免费次数按钮', {});
    toggleAddModal(false);
    // memberModel(true);
    // await Service.getLog();
  };

  useEffect(() => {
    requestChance();

    return () => { };
  }, []);

  return (
    <Modal open={isAddModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <section className="add-report-warp">
        <section className="add-report-content">
          <p className="prompt">提示
            <span onClick={() => cancel()} aria-hidden="true"><CloseIcon20 /></span>
          </p>
          <p className="add-query">您的薪酬报告免费查询仅剩：{count}次，立刻点击下方获取更多免费查询机会！</p>
          <p className="telephone">顾问专属电话：{userInfo?.saleInfo?.phone}</p>
        </section>
        <section className="bottom-action" style={{
          justifyContent: userInfo?.config?.survey_completed ? 'space-around' : '',
        }}>
          <SubButton onClick={onSure}>
            直接联系顾问
          </SubButton>
          {!userInfo?.config?.survey_completed && (
            <NextButton onClick={getNumber}>
              获取免费次数
            </NextButton>
          )}
        </section>
      </section>
    </Modal>
  );
};

export default observer(AddReportModal);
